import { StepsLayout } from "@funded-here-interface/common";
import ContentLoader from "@funded-here-interface/common/src/components/ContentLoader/ContentLoader";
import { FC, ReactNode, Suspense } from "react";

import NavBar from "../../components/NavBar/NavBar";
import { useStyles } from "./onboardinglayout.styles";

interface IProps {
  content: ReactNode;
  showSteps?: boolean;
  step: number;
  totalSteps?: number;
  stepContainerTop?: string;
  stepContainerLeft?: number;
}

const OnboardingLayout: FC<IProps> = (props) => {
  const { content, showSteps, step, totalSteps, stepContainerTop, stepContainerLeft } = props;
  const { classes } = useStyles();

  return (
    <div className={classes.mainContainer} style={{ backgroundColor: "#fff" }}>
      <NavBar />

      {showSteps && <StepsLayout currentStep={step} totalSteps={totalSteps} />}
      <div
        className={classes.stepContainer}
        style={{ top: stepContainerTop, left: stepContainerLeft }}
      >
        <Suspense fallback={<ContentLoader />}>{content}</Suspense>
      </div>
    </div>
  );
};

export default OnboardingLayout;
